module.exports = __webpack_public_path__ + "bg1.jpg?84800afea543d72581adf2c5b1ad94ce";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg1.jpg
// module id = 224
// module chunks = 0